// tslint:disable:max-line-length

import * as React from "react";
import {ReactNode} from "react";
import TranslateNew from "@translate/TranslateNew";
import {Dialog as MUIDialog, DialogActions, DialogContent, DialogTitle, WithStyles, withStyles} from "@material-ui/core";
import {DialogStyle} from "@components/common/dialog/dialog.style";

const tn: TranslateNew = TranslateNew.getInstance();

interface IDialogProps extends WithStyles<typeof DialogStyle> {
  open: boolean;
  onClose?: () => void;
  title?: ReactNode;
  content?: ReactNode;
  actions?: ReactNode;
  fullWidth?: boolean;
  children?: ReactNode;
}

class Dialog extends React.Component<IDialogProps> {

  constructor(props: any) {
    super(props);
  }

  public render() {
    const {classes, open, onClose, title, actions, content, fullWidth, children} = this.props;

    return (
      <MUIDialog
        open={open}
        onClose={onClose}
        fullWidth={fullWidth}
        classes={{
          paper: classes.paper,
        }}
        maxWidth="md"
        BackdropProps={{
          className: classes.backdrop,
        }}
      >
        {children
          ?
          children
          : (
            <>
              {title && (
                <DialogTitle
                  classes={{
                    root: classes.dialogTitle,
                  }}
                >
                  {title}
                </DialogTitle>
              )}
              {content && (
                <DialogContent
                  classes={{
                    root: classes.dialogContent,
                  }}>
                  {content}
                </DialogContent>
              )}
              {actions && (
                <DialogActions
                  classes={{
                    root: classes.dialogActions,
                  }}>
                  {actions}
                </DialogActions>
              )}
            </>
          )
        }
      </MUIDialog>
    );
  }
}

export default withStyles(DialogStyle)(Dialog);



// WEBPACK FOOTER //
// ./src/components/common/dialog/dialog.component.tsx